export const checkData=(Type, txt)=>{
    let textreturn = "";
    switch (Type) {
        case "number": 
            if (typeof txt  !==  "undefined" && txt !== ""  ) {
                textreturn = txt
            } else {
                textreturn = "0"
            } 
            break;

            case "money": 
            if (typeof txt  !== "undefined" && txt !== "" ) {
                textreturn = txt
            } else {
                textreturn = "0.00"
            } 
            break;
            case "text": 
            if (typeof txt  !==  "undefined" && txt !== ""  ) {
                textreturn = txt
            } else {
                textreturn = ""
            }  
            break; 
        default:
            break;
    } 
    return textreturn
}